import { IconButton } from '@material-ui/core';
import { CheckCircleOutline, ListAltOutlined, RemoveCircleOutline, Search } from '@material-ui/icons';
import LockIcon from '@material-ui/icons/LockOpen';
import { Form } from '@sketchpixy/rubix';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { change, Field, reduxForm } from 'redux-form';
import { GREEN, MATCH_TAG_MODE, VIRTUAL_INTERCOM_EXTENSION_GROUPS_LIMIT, VIRTUAL_INTERCOM_EXTENSION_GROUPS_LIMIT_PARAMETERS, VIRTUAL_INTERCOM_VIEW_MODES, VIRTUAL_INTERCOM_VIEW_MODES_PARAMETERS } from '../../../_config/consts';
import { isSmartLockOnline } from '../../../_config/utils.js';
import ClockLockIconCustom from '../../CustomIcons/ClockLockIconCustom.jsx';
import IntercomExtensionIconCustom from '../../CustomIcons/IntercomExtensionIconCustom.jsx';
import MapIconCustom from '../../CustomIcons/MapIconCustom.jsx';
import QRCodeScanIconCustom from '../../CustomIcons/QRCodeScanIconCustom.jsx';
import InfoSection from '../../InfoSection/InfoSection.jsx';
import ExtensionGroupsSelectorField from '../Elements/ExtensionGroupsSelectorField.jsx';
import FormFlatContainer from '../Elements/FormFlatContainer.jsx';
import MDRadioButtonsGroupField from '../Elements/MDRadioButtonsGroup/MDRadioButtonsGroupField.js';
import VirtualIntercomLocksSelectorField from '../Elements/VirtualIntercomLocksSelectorField.jsx';
import CustomField from '../Fields/CustomField.jsx';
import MapSelectionField from '../Fields/MapSelectionField.jsx';
import MDSwitchView from '../Fields/MDSwitch/MDSwitchView.jsx';
import SentenceSelectorInputField from '../Fields/SentenceSelectorInputField.jsx';
import PencilBoxOutlineIconCustom from '../../CustomIcons/PencilBoxOutlineIconCustom.jsx';

const validate = (values, props) => {
  const errors = {};
  const { virtualIntercomLimits } = props;
  
  if (!values.name) {
    errors.name = 'required';
  }
  if (!values.extensionGroupMode) {
    errors.extensionGroupMode = 'required';
  }
  if (values.extensionGroupMode === VIRTUAL_INTERCOM_EXTENSION_GROUPS_LIMIT.LIMITED && (!values.groupIds || values.groupIds.length === 0)) {
    errors.groupIds = 'required';
  }
  if (!values.geolocation) {
    errors.geolocation = 'required';
  }
  
  // Max call duration validation
  if (virtualIntercomLimits && virtualIntercomLimits.maxCallDuration !== -1) {
    const callDuration = parseInt(values.maxCallDurationSeconds)|| 0;
    if (callDuration > virtualIntercomLimits.maxCallDuration) {
      errors.maxCallDurationSeconds = 'virtualIntercomMaxCallDurationExceeded';
    }
  }
  
  return errors;
};

@reduxForm({ form: 'VirtualIntercomForm', validate })
@connect(state => ({ 
  form: state.form.VirtualIntercomForm, 
  lockers: state.lockers, 
  allLocks: state.lockers.locks.content,
  extensionGroups: state.intercom.extensionGroups.content,
  allExtensions: state.intercom.allExtensions,
  virtualIntercomLimits: state.intercom.virtualIntercomLimits,
}))
class VirtualIntercomForm extends React.Component {
  
  constructor(props) {
    super(props);
    const latitudeValue = props && props.form && props.form.values && props.form.values.latitude && props.form.values.latitude !== null;
    const longitudeValue = props && props.form && props.form.values && props.form.values.longitude && props.form.values.longitude !== null;
    this.state = {
      showMapSelection: Boolean(latitudeValue && longitudeValue),
    };
  }

  async componentDidMount() {
    const { intercom } = this.props;
    this.init(intercom)
  }

  componentWillReceiveProps(nextProps) {
    const { intercom: intercomOld } = this.props;
    const { intercom } = nextProps;
    if (intercom.id !== intercomOld.id) {
      this.init(intercom);
      const latitudeValue = intercom && intercom.latitude && intercom.latitude !== null;
      const longitudeValue = intercom && intercom.longitude && intercom.longitude !== null;
      if (latitudeValue && longitudeValue) {
        this.setState({ showMapSelection: true });
      } else {
        this.setState({ showMapSelection: false });
      }
    } 
  }

  async init(intercom) {
    const { dispatch } = this.props;

    dispatch(change('VirtualIntercomForm', 'smartLocks', intercom.smartLocks || []));
    dispatch(change('VirtualIntercomForm', 'smartLockIds', intercom.smartLocks ? intercom.smartLocks.map(e=>{return e.id}) : []));
    dispatch(change('VirtualIntercomForm', 'lockTagMatchingMode', MATCH_TAG_MODE.AT_LEAST_ONE_TAG));
    dispatch(change('VirtualIntercomForm', 'extensionGroupMode', intercom.groups && intercom.groups.length > 0 ? VIRTUAL_INTERCOM_EXTENSION_GROUPS_LIMIT.LIMITED : VIRTUAL_INTERCOM_EXTENSION_GROUPS_LIMIT.NO_LIMIT));
    
    if (intercom.groups && intercom.groups.length > 0) {
      dispatch(change('VirtualIntercomForm', 'groupIds', intercom.groups.map(group => group.id)));
    } else {
      dispatch(change('VirtualIntercomForm', 'groupIds', []));
    }
  }

  onChangeExtensionGroupMode(value) {
    const { dispatch } = this.props;
    if (value === VIRTUAL_INTERCOM_EXTENSION_GROUPS_LIMIT.NO_LIMIT) {
      dispatch(change('VirtualIntercomForm', 'groupIds', []));
    }
  }

  getExtensionsForSelectedGroups() {
    const { allExtensions, form } = this.props;
    const selectedGroupIds = form && form.values && form.values.groupIds ? form.values.groupIds : [];
    return _.filter(allExtensions, extension => {
      return _.some(selectedGroupIds, groupId => 
        (extension.groupId && extension.groupId === groupId) || 
        (extension.group && extension.group.id && extension.group.id === groupId)
      );
    });
  }

  updateLockIds(locks) {
    const { dispatch } = this.props;
    const smartLockIds_new = _.map(locks,e=>{return e.id})
    dispatch(change('VirtualIntercomForm', 'smartLockIds', smartLockIds_new));
  }

  onToggleEnableViewMode(selected) {
    const { dispatch } = this.props;
    dispatch(change('VirtualIntercomForm', 'viewMode', selected ? VIRTUAL_INTERCOM_VIEW_MODES.GROUP_SELECTION_LIST : VIRTUAL_INTERCOM_VIEW_MODES.EXTENSIONS_LIST));
  }

  onToggleMapSelection(selected) {
    const { dispatch } = this.props;
    this.setState({ showMapSelection: selected });
    
    // Clear the geolocation value when hiding the map
    if (!selected) {
      dispatch(change('VirtualIntercomForm', 'latitude', null));
      dispatch(change('VirtualIntercomForm', 'longitude', null));
      dispatch(change('VirtualIntercomForm', 'radiusMeters', null));
      dispatch(change('VirtualIntercomForm', 'geolocation', null));
    }
  };

  render() {
    const { form, extensionGroups, allExtensions, dispatch, onOpenLockRemotely, 
      locksFilteredByTags, availableLockTags, onLockTagsChange, 
      onLockInputChange, onFetchMoreLocks, onLockFilterModeChange, onDownloadHyperTileQRCode,
      virtualIntercomLimits } = this.props;
    const { showMapSelection } = this.state;

    const extensionGroupMode = form && form.values && form.values.extensionGroupMode;

    const viewMode = form && form.values && form.values.viewMode || VIRTUAL_INTERCOM_VIEW_MODES.EXTENSIONS_LIST;
    
    const isViewModeDisabled = virtualIntercomLimits && !virtualIntercomLimits.extensionGroupingActive;
    const hasMaxCallDurationLimit = virtualIntercomLimits && virtualIntercomLimits.maxCallDuration !== -1;
    const maxCallDurationAllowed = virtualIntercomLimits ? virtualIntercomLimits.maxCallDuration : -1;

    const extensionGroupOptions = [
      {
        label: <Entity entity={VIRTUAL_INTERCOM_EXTENSION_GROUPS_LIMIT_PARAMETERS.NO_LIMIT.label} />,
        value: VIRTUAL_INTERCOM_EXTENSION_GROUPS_LIMIT.NO_LIMIT,
      },
      {
        label: <Entity entity={VIRTUAL_INTERCOM_EXTENSION_GROUPS_LIMIT_PARAMETERS.LIMITED.label} />,
        value: VIRTUAL_INTERCOM_EXTENSION_GROUPS_LIMIT.LIMITED,
      },
    ];

    const extensionViewModeOptions = [
      {
        label: <Entity entity={VIRTUAL_INTERCOM_VIEW_MODES_PARAMETERS.EXTENSIONS_LIST.label} />,
        value: VIRTUAL_INTERCOM_VIEW_MODES.EXTENSIONS_LIST,
      },
      {
        label: <Entity entity={VIRTUAL_INTERCOM_VIEW_MODES_PARAMETERS.GROUP_SELECTION_LIST.label} />,
        value: VIRTUAL_INTERCOM_VIEW_MODES.GROUP_SELECTION_LIST,
      },
    ];

    const initialLocks = form && form.values && form.values.smartLocks
    const isEditing = form && form.values && form.values.id;
    const intercomHyperTile = form && form.values && form.values.hyperTile;
    return (
      <Form>
        <FormFlatContainer
          title="virtualIntercomData"
          icon={<PencilBoxOutlineIconCustom style={{ width: 22, height: 22, marginBottom: 1 }} />}
          containerStyle={{ marginRight: 10, marginTop: 0 }}
        >
            <Entity
              componentClass={Field}
              name="name"
              componentAttribute="placeholder"
              entity="insertName"
              title={<Entity entity="name" />}
              component={CustomField}
              type="text"
              containerStyle={{ marginTop: 20, marginLeft: 5 }}
              mandatory
            />
            {intercomHyperTile && (
              <div style={{ padding: 5, marginTop: 10, marginLeft: 5 }}>
              <h3 style={{ margin: 0, color: '#3f3f3f', fontSize: 18, fontWeight: 'bold' }}>HyperTile</h3>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 3 }}>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    {intercomHyperTile.name ? <h3 style={{ margin: 0, fontSize: 16 }}>{intercomHyperTile.name}</h3> : ''}
                    {intercomHyperTile.serialNumber ? <h3 style={{ margin: 0, marginLeft: 5, fontSize: 16 }}>({intercomHyperTile.serialNumber})</h3> : ''}
                  </div>
                  <IconButton onClick={() => onDownloadHyperTileQRCode(intercomHyperTile.serialNumber)} style={{ marginLeft: 15 }}>
                    <QRCodeScanIconCustom style={{ width: 23, color: '#3f3f3f' }} />
                    <Search style={{ position: 'absolute', bottom: 2, left: -2, color: '#3f3f3f', borderRadius: 10,fontSize: 20 }} />
                  </IconButton>
                </div>
              </div>
            )}
          </FormFlatContainer>
          <FormFlatContainer
            title="virtualIntercomExtensionGroups"
            subtitle="virtualIntercomExtensionGroupsSubtitle"
            icon={<IntercomExtensionIconCustom style={{ width: 22 , height: 22 }} />}
            titleStyle={{ fontSize: 20 }}
            containerStyle={{ marginRight: 10 }}
          >
            <Field
              name="extensionGroupMode"
              title={<Entity entity="extensionGroupMode" />}
              component={MDRadioButtonsGroupField}
              containerstyle={{ paddingLeft: 15, marginTop: 0 }}
              showErrorLabel
              options={extensionGroupOptions}
              onHandleChange={value => this.onChangeExtensionGroupMode(value)}
            />

            {extensionGroupMode === VIRTUAL_INTERCOM_EXTENSION_GROUPS_LIMIT.LIMITED && (
              <div style={{ marginTop: 20 }}>
                <ExtensionGroupsSelectorField
                  formName="VirtualIntercomForm"
                  name="groupIds"
                  selectedGroupsFieldName="groupIds"
                  extensionGroups={extensionGroups}
                  form={form}
                  allExtensions={allExtensions}
                  title="selectExtensionGroups"
                  placeholder="selectExtensionGroupsSearch"
                  selectionSectionTitle="extensionsInSelectedGroups"
                  selectionSectionSubtitle="extensionsInSelectedGroupsSubtitle"
                  noExtensionsInSelectedGroups="noExtensionGroupsSelected"
                />
              </div>
            )}
          </FormFlatContainer>
          <FormFlatContainer
            title="virtualIntercomSmartLocks"
            subtitle="virtualIntercomSmartLocksSubtitle"
            icon={<LockIcon style={{ width: 22, height: 22, marginBottom: 2 }} />}
            titleStyle={{ fontSize: 20 }}
            containerStyle={{ marginRight: 10 }}
          >
            <div style={{paddingLeft: 6 }}>
              <VirtualIntercomLocksSelectorField
                selectorFieldName="lockTagMatchingMode"
                name="intercomSmartLockTags"
                tags={availableLockTags}
                selectedTags={locksFilteredByTags}
                form={form}
                isOptional
                title="searchForLocks"
                placeholder="virtualIntercomLocksSearchPlaceholder"
                listTitle="virtualIntercomLocksSearchResultsTitle"
                selectionSectionTitle="virtualIntercomLocksSelectionTitle"
                selectionSectionSubtitle={null}
                selectionSectionEmptySubtitle="virtualIntercomLocksSelectionEmpty"
                initialValues={initialLocks || []}
                onFetchMoreItems={page => onFetchMoreLocks(page)}
                onTagsChange={values => onLockTagsChange(values)}
                onInputChange={value => onLockInputChange(value)}
                onFilterModeChange={values => onLockFilterModeChange(values)}
                onToggleLockId={locks => this.updateLockIds(locks)}
                lockHasErrorCondition={lock => !isSmartLockOnline(lock)}
                canEditLocks
                onOpenLockRemotely={onOpenLockRemotely}
                errorMessage="virtualIntercomLocksError"
              />
            </div>
          </FormFlatContainer>
          <FormFlatContainer
            title="virtualIntercomViewModeTitle"
            titleStyle={{ fontSize: 20 }}
            subtitle="virtualIntercomViewModeSubtitle"
            icon={<ListAltOutlined style={{ width: 22, height: 22 }} />}
            containerStyle={{ marginRight: 10 }}
          >
            <Field
              name="viewMode"
              title={<Entity entity="viewMode" />}
              component={MDRadioButtonsGroupField}
              containerstyle={{ paddingLeft: 15, marginTop: 0 }}
              showErrorLabel
              disabled={isViewModeDisabled}
              options={extensionViewModeOptions}
            />
            {isViewModeDisabled && (
              <InfoSection
                gravity="warning"
                title="extensionGroupingDisabled"
                containerStyle={{ marginBottom: 15 }}
              />
            )}
          </FormFlatContainer>
          <FormFlatContainer
            title="virtualIntercomCallDurationTitle"
            titleStyle={{ fontSize: 20 }}
            subtitle="virtualIntercomCallDurationSubtitle"
            icon={<ClockLockIconCustom style={{ width: 22, marginTop: 2, marginRight: 2 }} />}
            containerStyle={{ marginRight: 10 }}
          >
            {hasMaxCallDurationLimit && (
              <InfoSection
                gravity="info"
                title={<Entity entity="virtualIntercomCallDurationLimitInfo" data={{ maxSeconds: maxCallDurationAllowed }} />}
                containerStyle={{ marginBottom: 15 }}
              />
            )}
            <Field
              id="maxCallDurationSeconds"
              name="maxCallDurationSeconds"
              component={SentenceSelectorInputField}
              unit="seconds"
              sentence={L20NContext.getSync('maxCallDurationSecondsSentence')}
              containerStyle={{ marginTop: 10 }}
            />
          </FormFlatContainer>
          <FormFlatContainer
            title="virtualIntercomStatus"
            subtitle="virtualIntercomStatusSubtitle"
            icon={<CheckCircleOutline style={{ width: 22, height: 22 }} />}
            titleStyle={{ fontSize: 20 }}
            containerStyle={{ marginRight: 10 }}
          >
            <div style={{paddingLeft: 6}}>
              <Field
                name="enabled"
                component={MDRadioButtonsGroupField}
                options={[
                  {
                    value: true,
                    label: (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h5 style={{ color: GREEN, margin: 0, marginRight: 10, fontSize: 16 }}>
                          <Entity entity="virtualIntercomStatusEnabled" />
                        </h5>
                        <CheckCircleOutline style={{ fontSize: 20, color: GREEN }} />
                      </div>
                    ),
                  },
                  {
                    value: false,
                    label: (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h5 style={{ color: 'grey', margin: 0, marginRight: 10, fontSize: 16 }}>
                          <Entity entity="virtualIntercomStatusDisabled" />
                        </h5>
                        <RemoveCircleOutline style={{ fontSize: 20, color: 'grey' }} />
                      </div>
                    ),
                  },
                ]}
              />
            </div>
          </FormFlatContainer>
          <FormFlatContainer
            title="virtualIntercomGeolocation"
            subtitle="virtualIntercomGeolocationSubtitle"
            icon={<MapIconCustom style={{ width: 22, height: 22 }} />}
            titleStyle={{ fontSize: 20 }}
            containerStyle={{ marginRight: 10 }}
          >
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', paddingLeft: 6 }}>
              <MDSwitchView
                checked={showMapSelection}
                onSelect={(selected) => this.onToggleMapSelection(selected)}
                label={<Entity entity="enableGeolocationControl" />}
                titleStyle={{ fontWeight: showMapSelection ? 'bold' : 'normal', color: showMapSelection ? GREEN : '#3f3f3f', fontSize: 17, marginBottom: 1 }}
              />
            </div>
            {showMapSelection && (
              <Field
                name="geolocation"
                component={MapSelectionField}
                mandatory
              />
            )}
          </FormFlatContainer>
      </Form>
    );
  }
}

export default VirtualIntercomForm; 